/* Kwikpass drawer-menu account hook. Moved from the inline <script> in
   snippets/drawer-menu.liquid (rendered in the header on every page).
   The <script> tag in layout/theme.liquid passes the translated
   'layout.customer.account' string as data-account-label. */
(function () {
  var script = document.currentScript;
  var accountLabel = (script && script.getAttribute('data-account-label')) || 'Account';

  function autoLogin() {
    document.getElementById('kwik-pass-text').textContent = accountLabel;
    document.getElementById('kp-account').classList.remove('kwik-pass-login');
    document.getElementById('kp-account').classList.add('kwik-pass-account');
    document.getElementsByClassName('kwik-pass-account')[0].addEventListener('click', function (e) {
      handleShopifyLogin(e, "/account");
    });
  }
  window.autoLogin = autoLogin;

  window.addEventListener('user-loggedin', function (event) {
    var token = event && event.detail && event.detail.token;
    if (token) {
      autoLogin();
    }
  });

  function init() {
    var userToken = null;
    try { userToken = localStorage.getItem('KWIKSESSIONTOKEN'); } catch (e) {}
    if (userToken) {
      autoLogin();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
